import * as actionType from "../actions/actionType";

const initialState = {
  productName: "",
  creatorName: "",
  productCategory: "",
  creatorTier: "",
  creatorContentCategory: "",
  type: "creatorName",
  cateList: [],
  tableList: [],
  loading: false,
  pageNum: 1,
  pageSize: 20,
  tableListTotal: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SAMPLE_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
